const CookieKeys = {
    user: 'user',
    userAllowedCookie: 'userAllowedCookie'
};

export default CookieKeys;